import {createRouter, createWebHashHistory} from 'vue-router';

export const routes = [
    {
        path: '/',
        name: 'home',
        title: "继续教育",
        isHide: false,
        component: () => import("@/views/home.vue"),
    },
    {
        path: '/activity',
        name: 'activity',
        title: "活动报名",
        isHide: false,
        component: () => import("@/views/activity/index.vue"),
    },
    {
        path: '/activity/detail',
        name: 'activity-detail',
        title: "活动详情",
        isHide: true,
        component: () => import("@/views/activity/detail.vue"),
    },
    {
        path: '/activity/prove',
        name: 'activity-prove',
        title: "活动证明",
        isHide: true,
        component: () => import("@/views/activity/prove.vue"),
    },
    {
        path: '/subject',
        name: 'subject',
        title: "专属课程",
        isHide: false,
        component: () => import("@/views/subject/index.vue"),
    },
    {
        path: '/subject/detail',
        name: 'subject-detail',
        title: "课程详情",
        isHide: true,
        component: () => import("@/views/subject/detail.vue"),
    },
    {
        path: '/subject/order',
        name: 'subject-order',
        title: "购买课程",
        isHide: true,
        component: () => import("@/views/subject/order.vue"),
    },
    // {
    //     path: '/subject/study',
    //     name: 'subject-study',
    //     title: "学习课程",
    //     isHide: true,
    //     component: () => import("@/views/subject/study.vue"),
    // },
    {
        path: '/examresult',
        name: 'exam-result',
        title: "课程考试结果",
        isHide: true,
        component: () => import("@/views/exam/result.vue"),
    },
    {
        path: '/exam',
        name: 'exam',
        title: "课程考试",
        isHide: true,
        component: () => import("@/views/exam/index.vue"),
    },
    {
        path: '/about',
        name: 'about',
        title: "关于学会",
        isHide: false,
        component: () => import("@/views/about/index.vue"),
    },
    {
        path: '/personal',
        name: 'personal',
        title: "个人中心",
        isHide: false,
        component: () => import("@/views/personal/index.vue"),
    },
    {
        path: '/bindmobile',
        name: 'bindmobile',
        title: "绑定手机号",
        isHide: true,
        component: () => import("@/views/bindmobile.vue"),
    },
    // 捕获所有未匹配的路径重定向到 /home
    {
        path: '/:pathMatch(.*)*',
        redirect: '/',
        isHide: true,
    },
];
const router = createRouter({
    history: createWebHashHistory('/'),
    routes,
});
export default router;
